import styled from 'styled-components'

export const AccordionWrapper = styled.div`
  border-bottom: 1px solid #979797;
  padding: 0 14px;
  cursor: pointer;
  margin-bottom: 25px;
  outline: 0;
  &:last-child {
    margin-bottom: 0;
  }

  .title {
    font-size: 18px;
    font-weight: 700;
    color: #515151;
  }
  .title-wrapper {
    padding-bottom: 22px;
    display: flex;
    justify-content: space-between;
  }
  .content {
    font-size: 18px;
    transition: height 0.3s linear;
    > p {
      transition: opacity 0.3s ease;
      padding-bottom: 15px;
      color: #7b7b7b;
      font-size: 16px;
    }
  }
  .plus {
    width: 23px;
    height: 23px;
    position: relative;
    padding-left: 1rem;
  }
  .line {
    position: absolute;
    width: 3px;
    height: 23px;
    background-color: ${({ theme }) => theme.colors.primary};
    transition: transform 0.2s linear;
  }

  .rotated {
    transform: rotate(90deg);
  }
`
